<template>
  <div v-loading="loading">
    <div v-for="(item,index) in dataList" :key="index" class="item" v-if="!loading">
      <div style="display:flex;justify-items: center;justify-content: center;align-items: center">
        <div class="item-title" style="flex: 1">
          <div>产品名称: {{

              item.productName.indexOf("A") > -1?"学驾易(驾考服务)A": item.productName.indexOf("C") > -1?"学驾易(驾考服务)C": item.productName   }}</div>
          <!--        <div>: {{ item.COMPANY_NAME }}</div>-->
          <div>产品价格(元): {{ item.productFee }}</div>
          <div>产品介绍: <br/>  <span style="font-size: 16px">{{
              `意外伤残死亡赔偿限额： ${
                item.productDisabilityFee + "" || "--"
              }（元)\n每人补考费用限额：${
                item.productMakeupFee + "" || "--"
              }（元）\n每人意外医疗限额： ${
                item.productMedicalFee + "" || "--"
              }（元）\n保障期间： ${
                item.productInsuranceYear + "" || "--"
              } 年\n保单生效以后不能退保`
            }}</span></div>
          <div>产品状态:
            <van-tag type="success" size="large" v-if="item.productState == 1">正常</van-tag>

          </div>

        </div>
        <div style="text-align: center;width: 80px">
          <van-button style="width: 90%;"  type="primary" @click="toubaoViewOpen(item)">投保</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Config} from "../../components/common/api";
export default {
  name: "toubaoManager",
  data(){
    return{
      loading: true,
      dataList:[]
    }
  },
  mounted() {
    this.initTable();
  },
  methods:{
    initTable(){
        let self = this;
        const url = Config.api_url + "applets-server/api/product/list";
        this.$ajax({
          method: "get",
          url: url,
          params: {
            current: 1,
            pageSize: 10000,
            insuranceCompanyId: '',
            productState: 1,
            productName: '',
            productProvince: '',
          },
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': localStorage.getItem('token') }
        }).then(function (res) {
          const data = res.data;
          if (data.data) {
            self.dataList = data.data || [];
            self.loading = false
          } else {
            self.$message({
              type: "error",
              message: data.errorMessage,
              offset: 200
            });
          }
          self.loading = false
        }).catch(function (err) {
          self.$message({
            type: "error",
            message: '网络异常，请重试！',
            offset: 200
          });
        });
      },
    toubaoViewOpen(item){
      this.$router.push(`/toubaoView?productId=${item.productId}`)
    }
  }
}
</script>

<style scoped>
.item {
  margin: 10px;
  padding: 10px;

  /*font-size: 12px;*/
  background-color: #FFF;
  border: 1px solid #beb8b8;
  /* 水平偏移 垂直偏移 模糊半径 扩散半径 颜色 */
  box-shadow: 1px 1px 2px 0px rgba(190, 164, 164, 0.5);
}
</style>



// WEBPACK FOOTER //
// toubaoManager.vue?3cbed520